// extracted by mini-css-extract-plugin
export default {"boldText":"CustomBold_boldText__ZT4oZ","boldP":"CustomBold_boldP__McLi2"};